module.exports = __webpack_public_path__ + "static/media/alerta-gps-verde.67a22cfd.svg";